import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdminDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	fill: "none",
	stroke: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		transform: "scale(1.9) translate(-6.5,-6.5)",
		d: "M20 13.04l-1.439-1.91-3.331 2.49V7.09H12.8v6.53l-3.329-2.49-1.442 1.91 4.551 3.42H8v2.45h11.98v-2.45h-4.53z"
	})
});
export default SvgAdminDownload;
